import { documentServiceClient } from 'services/api/client';
import type { CurrencyDynamoItem, DocumentSettingsRepository } from './DocumentSettingsTypes.ts';
import type { CurrencyControllerGetCurrencies200 } from '@proposify/document-service-api-client';

const getAvailableCurrencies = async (): Promise<CurrencyDynamoItem[]> => {
  return await documentServiceClient.get<CurrencyControllerGetCurrencies200>('/currencies');
};

export const ApiDocumentSettingsRepository: DocumentSettingsRepository = {
  availableCurrencies: getAvailableCurrencies,
};
